// extracted by mini-css-extract-plugin
export default {"tooltip":"NQong","content":"ckzey","icon":"r9Rrb","title":"RSs9i","text":"wPY4Z"};